import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import BackgroundImage from 'gatsby-background-image';
import useBackgrounds from 'modules/useBackgrounds';
import PromoLogo from 'components/promo-logo';
import { useMediaQuery } from 'react-responsive';

import './hero.scss';

const Hero = ({ children, background, mobileBackground, logos }) => {
  const isMobile = useMediaQuery({ query: '(max-width: 1023px)' });
  const heroChildren = (
    <div className="hero__inner">
      <div className="hero__body">{children}</div>
      <div className="hero__border" />
      {logos ? (
        <div className="hero__logos">
          {logos.map(({ text, url, image, mobile }) => {
            return (
              <PromoLogo
                key={image}
                text={text}
                image={image}
                url={url}
                mobile={mobile}
              />
            );
          })}
        </div>
      ) : null}
    </div>
  );
  const classes = classnames({
    hero: true,
  });

  if (background) {
    const image = useBackgrounds(isMobile ? mobileBackground : background);
    return (
      <BackgroundImage Tag="section" className={classes} fluid={image}>
        {heroChildren}
      </BackgroundImage>
    );
  }
  return <section className={classes}>{heroChildren}</section>;
};

Hero.defaultProps = {
  background: '',
  mobileBackground: '',
  logos: [],
};

Hero.propTypes = {
  children: PropTypes.node.isRequired,
  background: PropTypes.string,
  mobileBackground: PropTypes.string,
  logos: PropTypes.arrayOf(PropTypes.object),
};

export default Hero;
